import ORDER_PRODUCT_DETAIL from './getOrderProduct.graphql'

export { ORDER_PRODUCT_DETAIL }
